import React, { memo } from 'react';
import { Box } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

/**
 * BorderBottom Box Component
 *
 * @param props
 * @returns {*}
 * @constructor
 */

/* ************ Style ************ */
const useStyles = makeStyles()(() => ({
  borderBottomBox: {
    display: 'flex',
    alignItems: 'flex-end',
    borderBottom: '1px solid',
  },
  defaultStyle: {
    height: '57px',
    maxWidth: '420px',
    fontSize: '24px',
    lineHeight: '28px',
    '& .label': {
      width: '145px',
      margin: '0 40px 0 0 ',
    },
  },
}));

/* ************ Type ************ */
type Props = {
  label?: string;
  value?: string | null;
  className?: string;
};

/* ************ Component ************ */
const BorderBottomBox: React.FC<React.PropsWithChildren<Props>> = memo((props) => {
  const { classes } = useStyles();
  const { label, value, className } = props;

  return (
    <Box className={`${classes.borderBottomBox} ${className || classes.defaultStyle}`}>
      {label && (
        <Box className="label" sx={{
          whiteSpace: "pre-wrap",
        }}>
          {label}
        </Box>
      )}
      <Box className="value">{value}</Box>
    </Box>
  );
});

export default BorderBottomBox;
